<template>
  <div class="p-resolution2">
    <section class="c-visible-pc" v-if="$store.state.isPc">
      <section class="cm-width c-m-a case-wrap">
        <p class="c-fs-40 c-fw-b c-mt-84">国有特大型通信企业监控中心案例2</p>
        <div class="c-mt-12 c-fs-16 c-c-text-grey">
          <span>2019-12-10 12:26</span><span class="c-ml-28">作者：猫维</span>
        </div>
        <div class="c-d-f c-ai-c c-mt-36">
          <div class="c-mr-12 c-dot"></div>
          <p class="c-fs-20 c-c-text-blue">客户简介</p>
        </div>
        <p class="c-mt-12 c-lh-38 c-fs-18 c-ta-j c-t-i">本文案例是一家大型国有企业，该企业已连续多年入选"世界500强企业"，已连续服务国内外客户近30年，主要经营固定电话、
          移动通信、卫星通信、互联网接入及应用等综合信息服务。作为建设网络强国、数字中国和智慧社会的主力军，作为云计算、大数据、人工智能等供给侧结构性改革的先行者和网络基础设施的提供者，
          该公司积极实践IT基础架构监控与上层业务互动，而乐维有幸成为了产品与技术解决方案提供商。
        </p>
        <div class="c-d-f c-ai-c c-mt-24">
          <div class="c-mr-12 c-dot"></div>
          <p class="c-fs-20 c-c-text-blue">项目背景</p>
        </div>
        <p class="c-mt-12 c-lh-38 c-fs-18 c-ta-j c-t-i">随着企业信息化建设特别是5G商用蓬勃开展，企业IT规模逐年扩大，一些设备老旧化、新老设备迭代、业务持续增长导致故障次数逐年增加。
          在采用集中有效的管理方式之前，管理相关方式相对滞后，且团队对现有IT系统软硬件缺乏系统有效的运维监视手段，系统配套的管理手段已经落后于业务进展的步伐，
          这样就造成了运维管理跟不上业务发展的工作矛盾。该企业现有的运维监控系统历经近10年开发建设，每年更新迭代，使用过开源和非开源产品，最终技术选型以开源Zabbix为底层委托乐维进行二次开发，
          需在其原监控基础上衍生个性化适应业务增长的运维工具。为解决此问题，乐维潜心研发一站式运维解决方案，一方面可以解决该企业监控系统目前存在的问题，另一方面帮助其搭建完整的智能运维架构，
          保持企业IT基础架构与业务可持续发展。
        </p>
        <div class="c-d-f c-ai-c c-mt-24">
          <div class="c-mr-12 c-dot"></div>
          <p class="c-fs-20 c-c-text-blue">监控规模</p>
        </div>
        <p class="c-mt-12 c-lh-38 c-fs-18 c-ta-j">共监控了内蒙、昌平、上海、贵州四区域核心机房，主机对象30000左右，数据日增量约100G</p>
        <img class="c-mt-36 c-cs-p pic" src="../../assets/monitor/virtual.jpg" preview="resolution2">
        <div class="c-d-f c-ai-c c-mt-40">
          <div class="c-mr-12 c-dot"></div>
          <p class="c-fs-20 c-c-text-blue">客户收益</p>
        </div>
        <div class="c-mt-16 c-lh-38 c-fs-18 c-ta-j">
          <p>1.保证上层业务系统运行通畅，因系统故障问题投诉明显下降，随着业务增长，相关IT配套发展更加有计划；</p>
          <p>2.规范IT资产管理，保障新旧设备对接入库，清晰权责，做到故障有预警，问题有人管；</p>
          <p>3.集中大屏展示，为上层领导决策提供依据，展现新时代IT建设新风貌。</p>
        </div>
        <div class="c-mt-24">
          <button class="c-btn-dark-156-nob" disabled>无</button>
          <button class="c-ml-12 c-btn-156" @click="toUrl('/resolution_case1')">上一个案例</button>
        </div>
      </section>
      <section class="cm-width c-m-a c-pb-164 case-card">
        <div class="c-d-f c-ai-c c-mt-80 c-mb-40">
          <img src="../../assets/index/icon.png">
          <span class="c-ml-12 c-ff-m c-fs-24">其他案例</span>
        </div>
        <div class="c-d-f c-ta-j c-c-text-grey">
          <div class="c-p-40 c-bc-white case-item">
            <div class="case-img"></div>
            <p class="c-fs-20 c-c-text-blue c-mt-28">其他案例标题</p>
            <p class="c-fs-14 c-lh-22 c-mt-16">这里是内容这里是内容这里是内容，这里是内容这里是，内容这里是内容这里是内容这里是内容这里是内容</p>
          </div>
          <div class="c-p-40 c-ml-24 c-bc-white case-item">
            <div class="case-img"></div>
            <p class="c-fs-20 c-c-text-blue c-mt-28">其他案例标题</p>
            <p class="c-fs-14 c-lh-22 c-mt-16">这里是内容这里是内容这里是内容，这里是内容这里是，内容这里是内容这里是内容这里是内容这里是内容</p>
          </div>
          <div class="c-p-40 c-ml-24 c-bc-white case-item">
            <div class="case-img"></div>
            <p class="c-fs-20 c-c-text-blue c-mt-28">其他案例标题</p>
            <p class="c-fs-14 c-lh-22 c-mt-16">这里是内容这里是内容这里是内容，这里是内容这里是，内容这里是内容这里是内容这里是内容这里是内容</p>
          </div>
        </div>
      </section>
    </section>
    <section class="c-visible-mobile" v-if="!$store.state.isPc">
      <section class="cm-width c-m-a case-wrap-mobile">
        <p class="c-fs-19 c-fw-b c-mt-40">国有特大型通信企业监控中心案例</p>
        <div class="c-mt-8 c-fs-12 c-c-text-grey">
          <span>2019-09-10 12:19</span><span class="c-ml-20">作者：猫维</span>
        </div>
        <div class="c-d-f c-ai-c c-mt-24">
          <div class="c-mr-8 c-dot"></div>
          <p class="c-fs-15 c-c-text-blue">客户简介</p>
        </div>
        <p class="c-mt-12 c-lh-20 c-fs-12 c-c-text-grey c-ta-j c-t-i">本文案例是一家大型国有企业，该企业已连续多年入选"世界500强企业"，已连续服务国内外客户近30年，主要经营固定电话、
          移动通信、卫星通信、互联网接入及应用等综合信息服务。作为建设网络强国、数字中国和智慧社会的主力军，作为云计算、大数据、人工智能等供给侧结构性改革的先行者和网络基础设施的提供者，
          该公司积极实践IT基础架构监控与上层业务互动，而乐维有幸成为了产品与技术解决方案提供商。
        </p>
        <div class="c-d-f c-ai-c c-mt-24">
          <div class="c-mr-8 c-dot"></div>
          <p class="c-fs-15 c-c-text-blue">项目背景</p>
        </div>
        <p class="c-mt-12 c-lh-20 c-fs-12 c-c-text-grey c-ta-j c-t-i">随着企业信息化建设特别是5G商用蓬勃开展，企业IT规模逐年扩大，一些设备老旧化、新老设备迭代、业务持续增长导致故障次数逐年增加。
          在采用集中有效的管理方式之前，管理相关方式相对滞后，且团队对现有IT系统软硬件缺乏系统有效的运维监视手段，系统配套的管理手段已经落后于业务进展的步伐，
          这样就造成了运维管理跟不上业务发展的工作矛盾。该企业现有的运维监控系统历经近10年开发建设，每年更新迭代，使用过开源和非开源产品，最终技术选型以开源Zabbix为底层委托乐维进行二次开发，
          需在其原监控基础上衍生个性化适应业务增长的运维工具。为解决此问题，乐维潜心研发一站式运维解决方案，一方面可以解决该企业监控系统目前存在的问题，另一方面帮助其搭建完整的智能运维架构，
          保持企业IT基础架构与业务可持续发展。
        </p>
        <div class="c-d-f c-ai-c c-mt-24">
          <div class="c-mr-8 c-dot"></div>
          <p class="c-fs-15 c-c-text-blue">监控规模</p>
        </div>
        <p class="c-mt-12 c-lh-20 c-fs-12 c-c-text-grey c-ta-j">共监控了内蒙、昌平、上海、贵州四区域核心机房，主机对象30000左右，数据日增量约100G</p>
        <img class="c-mt-24 pic-mobile" src="../../assets/monitor/virtual.jpg" preview="resolution-m2">
        <div class="c-d-f c-ai-c c-mt-24">
          <div class="c-mr-8 c-dot"></div>
          <p class="c-fs-15 c-c-text-blue">客户收益</p>
        </div>
        <div class="c-mt-16 c-lh-20 c-fs-12 c-c-text-grey c-ta-j">
          <p>1.保证上层业务系统运行通畅，因系统故障问题投诉明显下降，随着业务增长，相关IT配套发展更加有计划；</p>
          <p>2.规范IT资产管理，保障新旧设备对接入库，清晰权责，做到故障有预警，问题有人管；</p>
          <p>3.集中大屏展示，为上层领导决策提供依据，展现新时代IT建设新风貌。</p>
        </div>
        <div class="c-d-f c-jc-c c-mt-24">
          <button class="c-btn-dark-156-nob" disabled>无</button>
          <button class="c-ml-12 c-btn-156" @click="toUrl('/resolution_case1')">上一个案例</button>
        </div>
      </section>
      <section class="cm-width c-m-a c-pb-40 case-card-mobile">
        <div class="c-d-f c-ai-c c-mt-40 c-mb-24">
          <img src="../../assets/index/icon.png" class="c-icon-mobile">
          <span class="c-ml-8 c-ff-m c-fs-16">其他案例</span>
        </div>
        <div class="c-o-s">
          <div class="c-d-f c-ta-j c-c-text-grey case-wrap-mobile">
            <div class="c-p-20 c-bc-white case-item">
              <div class="case-img"></div>
              <p class="c-fs-14 c-c-text-blue c-mt-20">其他案例标题</p>
              <p class="c-fs-12 c-lh-20 c-mt-8">这里是内容这里是内容这里是内容，这里是内容这里是，内容这里是内容这里是内容这里是内容这里是内容</p>
            </div>
            <div class="c-p-20 c-ml-12 c-bc-white case-item">
              <div class="case-img"></div>
              <p class="c-fs-14 c-c-text-blue c-mt-20">其他案例标题</p>
              <p class="c-fs-12 c-lh-20 c-mt-8">这里是内容这里是内容这里是内容，这里是内容这里是，内容这里是内容这里是内容这里是内容这里是内容</p>
            </div>
            <div class="c-p-20 c-ml-12 c-bc-white case-item">
              <div class="case-img"></div>
              <p class="c-fs-14 c-c-text-blue c-mt-20">其他案例标题</p>
              <p class="c-fs-12 c-lh-20 c-mt-8">这里是内容这里是内容这里是内容，这里是内容这里是，内容这里是内容这里是内容这里是内容这里是内容</p>
            </div>
          </div>
        </div>
      </section>
    </section>
  </div>
</template>

<script>

export default {
  name: 'resolution',
  data () {
    return {

    }
  },
  methods: {
    toUrl (url) {
      this.$router.push(url)
    }
  }
}
</script>

<style lang="scss">
.p-resolution2 {
  min-height: calc(100vh - 90px - 525px);
  .pic {
    height: 417px;
  }
  .pic-mobile {
    width: 100%;
  }
  .case-card {
    .case-item {
      position: relative;
      cursor: pointer;
      border-radius: 1px;
      box-shadow: 0 8px 34px 0 rgba(0, 31, 255, 0.05);
      transition: all 0.3s ease-in-out;
      &::before {
        content: "";
        width: 0;
        height: 4px;
        background: $orange;
        position: absolute;
        top: 0;
        left: 50%;
        transition: all 0.3s;
      }
      &:hover {
        transform: translateY(-16px);
      }
      &:hover::before {
        left: 0;
        width: 100%;
      }
      .case-img {
        height: 126px;
        background: url('../../assets/index/logo-plus.png');
        background-size: cover;
      }
    }
  }
  .case-card-mobile {
    .case-wrap-mobile {
      width: 680px;
      .case-item {
        position: relative;
        border-radius: 1px;
        box-shadow: 0 8px 34px 0 rgba(0, 31, 255, 0.05);
        .case-img {
          height: 63px;
          background: url('../../assets/index/logo-plus.png');
          background-size: cover;
        }
      }
    }
  }
}
</style>
